<p>create-allocation works!</p>
